<template>
  <div
    :class="[
      'tw:rounded-lg tw:transition-colors tw:duration-150',
      bordered ? 'tw:border' : '',
      padding ? paddingClass : '',
      { 'skeleton-play': skeleton },
    ]"
    :style="{ backgroundColor: bg, borderColor: bordered ? borderColor : undefined }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  /** Show border */
  bordered?: boolean
  /** Background color */
  bg?: string
  /** Border color */
  borderColor?: string
  /** Padding size */
  padding?: 'none' | 'sm' | 'md' | 'lg'
  /** Skeleton loading */
  skeleton?: boolean
}>(), {
  bordered: true,
  bg: 'var(--contentcolor)',
  borderColor: 'var(--bordercolor)',
  padding: 'md',
  skeleton: false,
})

const paddingClass = computed(() => ({
  none: '',
  sm: 'tw:p-3',
  md: 'tw:p-5',
  lg: 'tw:p-7',
}[props.padding]))
</script>
